import { MembershipFragment } from '@occc/graphql';

import { MemberWallets } from './Wallets/MemberWallets';

type Props = {
  memberId: MembershipFragment['id'];
};

export const WalletsContent: React.FC<Props> = ({ memberId }) => {
  return <MemberWallets membershipId={memberId} />;
};
